export const auditProcessNames = {
  JobUpdateProcessInitiated: "JobUpdateProcessInitiated",
  JobUpdateProcessCompleted: "JobUpdateProcessCompleted",
  JobUpdateFormProcessInitiated: "JobUpdateFormProcessInitiated",
  JobUpdateFormProcessCompleted: "JobUpdateFormProcessCompleted",
  JobUpdateProcessFailed: "JobUpdateProcessFailed",
  JobUpdateFormProcessFailed: "JobUpdateFormProcessFailed",
  JobUpdateProcessAutoSaveInit: "JobUpdateProcessAutoSaveInit",
  JobUpdateProcessAutoSaveComplete: "JobUpdateProcessAutoSaveComplete",
  JobUpdateProcessAutoSaveFailed: "JobUpdateProcessAutoSaveFailed",
  JobFetchProcessInitiated: "JobFetchProcessInitiated",
  JobFetchProcessCompleted: "JobFetchProcessCompleted",
  CsrReadyJob: "Csr-ReadyJobs"
};
